let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ouaE")).then(() => parcelRequire('botwY'));